import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Tag } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const posts = [{
  id: 1,
  title: 'Essential Gear for Everest Base Camp',
  image: 'https://images.unsplash.com/photo-1548588627-f978862b85e1?q=80&w=2072&auto=format&fit=crop',
  category: 'Guides',
  date: 'Mar 15, 2024',
  height: 'h-96',
  link: '#blog-everest-gear'
}, {
  id: 2,
  title: 'Best Time to Visit Nepal',
  image: 'https://images.unsplash.com/photo-1585938389612-a552a28d6914?q=80&w=2060&auto=format&fit=crop',
  category: 'Tips',
  date: 'Feb 28, 2024',
  height: 'h-64',
  link: '#'
}, {
  id: 3,
  title: 'Culture of the Sherpa People',
  image: 'https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=2076&auto=format&fit=crop',
  category: 'Culture',
  date: 'Feb 10, 2024',
  height: 'h-80',
  link: '#'
}, {
  id: 4,
  title: 'Top 5 Short Treks in Nepal',
  image: 'https://images.unsplash.com/photo-1623492701902-47d3be136e96?q=80&w=2070&auto=format&fit=crop',
  category: 'Trekking',
  date: 'Jan 25, 2024',
  height: 'h-72',
  link: '#'
}, {
  id: 5,
  title: 'Acclimatization: How to Avoid Altitude Sickness',
  image: 'https://images.unsplash.com/photo-1533130061792-649d45df8c2d?q=80&w=1978&auto=format&fit=crop',
  category: 'Health',
  date: 'Jan 15, 2024',
  height: 'h-64',
  link: '#'
}, {
  id: 6,
  title: 'Bhutan Visa Guide 2024',
  image: 'https://images.unsplash.com/photo-1578565697042-45e396d36e3c?q=80&w=2070&auto=format&fit=crop',
  category: 'Travel Info',
  date: 'Jan 05, 2024',
  height: 'h-80',
  link: '#'
}];
export function BlogMasonry() {
  return <section className="py-20 bg-white" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <SectionHeading title="From the Blog" subtitle="Tips, stories, and guides for your next Himalayan adventure." data-id="element-26" />

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-27">
          {posts.map((post, index) => <motion.a key={post.id} href={post.link} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="break-inside-avoid group relative rounded-2xl overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300 block" data-id="element-28">
              <div className={`w-full ${post.height} relative`} data-id="element-29">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-30" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80" data-id="element-31" />

                <div className="absolute bottom-0 left-0 p-6 w-full" data-id="element-32">
                  <div className="flex items-center gap-4 text-xs text-gray-300 mb-3" data-id="element-33">
                    <span className="flex items-center gap-1 bg-white/20 backdrop-blur-sm px-2 py-1 rounded-md" data-id="element-34">
                      <Tag size={12} data-id="element-35" /> {post.category}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-36">
                      <Calendar size={12} data-id="element-37" /> {post.date}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-white group-hover:text-[#06B6D4] transition-colors" data-id="element-38">
                    {post.title}
                  </h3>
                </div>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}